module.exports = __webpack_public_path__ + "static/media/employee.fe84ef13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/employee.svg
// module id = 2191
// module chunks = 0